import { resolveStoreCartItemSelectionFlag } from './storeCartApiSync.utils';
import type { ICartInformation, ICartItemDetail } from '@/common/interfaces/cart.interface';

const normalizeStoreCartCartItem = (item: ICartItemDetail): ICartItemDetail => {
  const selectionFlag = resolveStoreCartItemSelectionFlag(item);

  if (selectionFlag == null) {
    return item;
  }

  return {
    ...item,
    is_selected: selectionFlag,
    isActive: selectionFlag === 1,
  };
};

/** API may return `{ cartItems }` or a bare array — normalize for store cart UI */
export const normalizeStoreCartApiResponse = (data: unknown): ICartItemDetail[] => {
  if (!data) {
    return [];
  }

  if (Array.isArray(data)) {
    return (data as ICartItemDetail[]).map(normalizeStoreCartCartItem);
  }

  const { cartItems } = data as ICartInformation;

  if (Array.isArray(cartItems)) {
    return cartItems.map(normalizeStoreCartCartItem);
  }

  return [];
};
